import { Controller } from "@hotwired/stimulus";

// Animación de confetti tras crear un AutoDM exitosamente.
//
// Replica el componente <Confetti waiting={100} /> del frontend (que usa
// react-confetti). En esta versión usamos CSS-only animations para evitar
// agregar una dependencia npm — particles generados con divs absolutos que
// caen y desaparecen en ~3 segundos.

const COLORS  = ["#fded1a", "#2bda31", "#0477f8", "#ff2f37", "#f4f4f4"];
const PIECES  = 80;
const FALL_MS = 3000;

export default class extends Controller {
  connect() {
    this._timeout = setTimeout(() => this._launch(), 100);
  }

  disconnect() {
    clearTimeout(this._timeout);
    if (this._container && this._container.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
  }

  _launch() {
    const container = document.createElement("div");
    container.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none;z-index:9999;overflow:hidden;";
    document.body.appendChild(container);
    this._container = container;

    for (let i = 0; i < PIECES; i++) {
      const piece = document.createElement("span");
      const left   = Math.random() * 100;
      const delay  = Math.random() * 500;
      const dur    = FALL_MS + Math.random() * 1500;
      const size   = 6 + Math.random() * 6;
      const color  = COLORS[Math.floor(Math.random() * COLORS.length)];
      const rotate = Math.random() * 360;

      piece.style.cssText = `
        position:absolute;
        top:-20px;
        left:${left}%;
        width:${size}px;
        height:${size * 0.4}px;
        background:${color};
        transform:rotate(${rotate}deg);
        animation: autodm-confetti-fall ${dur}ms ${delay}ms linear forwards;
        opacity:.9;
      `;
      container.appendChild(piece);
    }

    this._injectKeyframesOnce();

    setTimeout(() => {
      if (container.parentNode) container.parentNode.removeChild(container);
      this._container = null;
    }, FALL_MS + 2000);
  }

  _injectKeyframesOnce() {
    if (document.getElementById("autodm-confetti-style")) return;
    const style = document.createElement("style");
    style.id = "autodm-confetti-style";
    style.textContent = `
      @keyframes autodm-confetti-fall {
        0%   { transform: translateY(0) rotate(0deg); opacity: .95; }
        100% { transform: translateY(110vh) rotate(720deg); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }
}
